import styled, { css } from 'styled-components';

type WrapperProps = {
  maxWidth?: boolean;
};

export const Wrapper = styled.section<WrapperProps>`
  font-family: ${({ theme }) => theme.FONTS.MAIN};
  margin: 15rem 3.2rem 15rem 3.2rem;
  position: relative;

  @media ${({ theme }) => theme.DEVICE.LG} {
    margin: 15rem auto 15rem auto;
    ${({ maxWidth }) =>
      maxWidth &&
      css`
        max-width: 1308px;
      `}
  }
`;

const Blur = styled.div`
  z-index: -1;
  position: inherit;
`;

export const DesktopBlur = styled(Blur)`
  display: none;
  @media ${({ theme }) => theme.DEVICE.MD} {
    display: block;
  }
`;

export const MobileBlur = styled(Blur)`
  display: block;

  @media ${({ theme }) => theme.DEVICE.MD} {
    display: none;
  }
`;
